import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import ProfileForm from "../../../../../components/profile-form/profile-form";
import { gendersList } from "../../../../../constants/common";
import dayjs from "dayjs";

const PersonalInfo = ({ control, isEditMode }) => {
  return (
    <Row style={{ margin: "20px 0" }} gutter={[32, 16]}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="fullName"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Full Name"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="gender"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Select
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
              inputLabel="Gender"
              required
              isEdit={isEditMode}
            >
              {gendersList?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </ProfileForm.Select>
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="dob"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.DatePicker
              value={
                field.value ? dayjs(field.value) : null
              }
              allowClear={false}
              isEdit={isEditMode}
              inputLabel="Date of Birth"
              required
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="designation"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Designation"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default PersonalInfo;